import React from "react";
import { Home, CalendarClock, CalendarCheck, CalendarSync } from "lucide-react";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import PortalSwitch from "@/components/dashboard/PortalSwitch";

export default function SecretaryLayout() {
  const nav = [
    { to: "/secretaire", label: "Accueil", icon: Home, end: true },
    { to: "/secretaire/missions", label: "Mes missions", icon: CalendarCheck },
    { to: "/secretaire/disponibilites", label: "Mes disponibilités", icon: CalendarClock },
    { to: "/secretaire/calendrier", label: "Mon calendrier externe", icon: CalendarSync },
  ];
  return <DashboardLayout nav={nav} portalSwitch={<PortalSwitch />} />;
}
